import { useMutation, useQueryClient } from 'react-query';
import {
  updateBettieProfile,
  type UpdateBettieProfileBody,
  type UpdateBettieProfileResponse
} from '../../services/bettieProfileService';

export function useUpdateBettieProfile() {
  const queryClient = useQueryClient();
  return useMutation<
    UpdateBettieProfileResponse,
    Error,
    { body: UpdateBettieProfileBody; chatRoomId: string }
  >(({ body, chatRoomId }) => updateBettieProfile(body, chatRoomId), {
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(['bettieChatRoomPictures', variables.chatRoomId]);
      queryClient.invalidateQueries(['chatRoom', variables.chatRoomId]);
    }
  });
}
